import { Css } from '@/ui';
import { css } from '@emotion/core';
import { theme } from '../../../styles/theme';
import { Color } from '../../../styles/Color';

export const NavigationItemFont = css`
	font-family: inherit;
	font-size: ${theme.typography?.body?.size};
	font-weight: 400;
`;

export const MainNavigationItemActive = css`
	text-decoration: none;
	color: ${Color.PrimaryBlue};
	background-color: ${Color.PrimaryWhite};
	border-radius: ${Css.pxToRem(10)} ${Css.pxToRem(10)} ${Css.pxToRem(10)} 0px;
	transition: background-color 0.3s ease;

	&:hover {
		color: ${Color.PrimaryBlue};
	}

	svg {
		path {
			fill: ${Color.PrimaryBlue};
		}
	}
`;

export const focusVisibleAfterStyles = css`
	content: '';
	width: ${Css.pxToRem(30)};
	height: ${Css.pxToRem(30)};
	border-radius: 50%;
	position: absolute;
	left: ${Css.pxToRem(5)};
	top: ${Css.pxToRem(3)};
	z-index: -1;
`;

export const NavigationItemFocusState = (isIntersected?: boolean) => css`
	${focusVisibleAfterStyles}
	background-color: ${!isIntersected
		? Color.PrimaryBlue87
		: Color.PrimaryWhite};
`;

export const MainNavigationItemCommon = (
	showBackground?: boolean,
	type?: 'primary' | 'secondary',
) => css`
	${NavigationItemFont}
	color: ${type === 'primary' || showBackground
		? Color.SecondaryBlue1
		: Color.PrimaryWhite};
	display: inline-block;
	padding: ${Css.pxToRem(8)} ${Css.pxToRem(14)} ${Css.pxToRem(8)};

	svg {
		path {
			fill: currentColor;
		}
	}

	&:hover {
		position: relative;
		${type !== 'primary' &&
		!showBackground &&
		css`
			color: ${Color.PrimaryWhite};
		`}

		&:before {
			content: '';
			width: auto;
			height: ${Css.pxToRem(2)};
			background-color: ${type === 'primary' || showBackground
				? Color.PrimaryBlue
				: Color.PrimaryWhite};
			position: absolute;
			bottom: ${Css.pxToRem(8)};
			left: ${Css.pxToRem(12)};
			right: ${Css.pxToRem(12)};
		}
	}
`;
